import React, { useState } from "react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";

export const SiteForm = ({ site, onSave, onCancel, isEdit = false }) => {
  const [formData, setFormData] = useState({
    name: site?.name || '',
    location: site?.location || '',
    coordinator: site?.coordinator || '',
    pi_name: site?.pi_name || ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(site?.id, formData);
  };

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <div>
          <Label htmlFor="site-name">Site Name</Label>
          <Input
            id="site-name"
            value={formData.name}
            onChange={(e) => handleChange('name', e.target.value)}
            placeholder="Enter site name"
            required
          />
        </div>
        <div>
          <Label htmlFor="location">Location</Label>
          <Input
            id="location"
            value={formData.location}
            onChange={(e) => handleChange('location', e.target.value)}
            placeholder="Enter location"
          />
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <Label htmlFor="coordinator">Coordinator</Label>
          <Input
            id="coordinator"
            value={formData.coordinator}
            onChange={(e) => handleChange('coordinator', e.target.value)}
            placeholder="Enter coordinator name"
          />
        </div>
        <div>
          <Label htmlFor="pi_name">PI Name</Label>
          <Input
            id="pi_name"
            value={formData.pi_name}
            onChange={(e) => handleChange('pi_name', e.target.value)}
            placeholder="Enter PI name"
          />
        </div>
      </div>

      <div className="flex justify-end space-x-2 pt-4">
        <Button type="button" variant="outline" onClick={onCancel}>
          Cancel
        </Button>
        <Button type="submit">
          {isEdit ? 'Update Site' : 'Create Site'}
        </Button>
      </div>
    </form>
  );
};
